
// -------------------------------
// FinA Globo Smart Filter Compare Bridge Re-Init (Fix)
// -------------------------------

(() => {
  function getSectionDataEl() {
    return document.querySelector(
      [
        'script[data-section-data][data-section-id][data-section-type="static-collection"]',
        'script[data-section-data][data-section-id][data-section-type="static-collection-faceted-filters"]',
        'script[data-section-data][data-section-id][data-section-type="static-search"]',
        'script[data-section-data][data-section-id][data-section-type="static-search-faceted-filters"]'
      ].join(',')
    );
  }

  function reinitSection() {
    const dataEl = getSectionDataEl();
    if (!dataEl) return;

    const sectionRoot = dataEl.parentNode;
    const sectionId = dataEl.getAttribute('data-section-id');
    if (!sectionRoot || !sectionId) return;

    sectionRoot.dispatchEvent(new CustomEvent('shopify:section:unload', {
      bubbles: true,
      detail: { sectionId }
    }));

    sectionRoot.dispatchEvent(new CustomEvent('shopify:section:load', {
      bubbles: true,
      detail: { sectionId }
    }));
  }

  window.addEventListener('load', () => setTimeout(reinitSection, 0));
  window.addEventListener('globoFilterRenderCompleted', () => {
    setTimeout(reinitSection, 0);
  });
})();

